module.exports = __webpack_public_path__ + "img/face-swap-result.86029872.webp";